import { FORM_LIMIT } from '@/shared/constants/forms';

export const emotionCheckinSchema = {
  type: 'object',
  required: ['emotionMainUnique', 'questionDate', 'requestId'],
  properties: {
    questionDate: { type: 'string', format: 'date' },
    requestId: { type: 'string', minLength: 1, maxLength: 50 },
    emotionMainUnique: { type: 'string', minLength: 1, maxLength: 50 },
    notes: { type: 'string', maxLength: FORM_LIMIT.NOTE },
  },
  additionalProperties: false,
};
